export const KNOCK_ANSWERED = 'knockAnswered';
export const KNOCK_UPDATE = 'knockUpdate';
export const STREAM_RECORD_STATUS_CHANGED = 'streamRecordStatusChanged';
export const BROADCAST_JOIN_SYNC_SERVER_TIME = 'broadcastSyncServerTime';
export const BROADCAST_JOIN_SYNCED_SERVER_TIME = 'broadcastSyncedServerTime';
export const ATTENDEE_NETWORK_HEALTH_CHANGE = 'attendeeNetworkHealthChange';
export const LIMITED_BROADCAST_UPDATED = 'limitedBroadcastUpdated';
export const REAL_TIME = 'realTime';
